import { useMediaQuery } from 'react-responsive';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled, { css } from 'styled-components';
import {
  handleSelectIndividualMachine,
  handleUnSelectIndividualMachine,
} from '../../../store/slices/essSwitchSlice';

import {
  handleAddLocations,
  handleAddMachines,
  handleLocationSelect,
  handleMachineSelect,
  handleMachineSelectAlt,
  handleSelectAll,
  handleSelectedOne,
  selectMasterControls,
} from '../../../store/slices/masterControlSelectSlice';

import { handleResetAll } from '../../../store/slices/selectedMachinesSlice';
import {
  tesHandleSelectIndividualMachine,
  tesHandleUnSelectIndividualMachine,
} from '../../../store/slices/tesSwitchSlice';
import {
  tgsHandleSelectIndividualMachine,
  tgsHandleUnSelectIndividualMachine,
} from '../../../store/slices/tgsSwitchSlice';

import {
  flexBoxCenter,
  flexDirectionColumn,
  justifyContentSpaceBetween,
  layerA,
  layerA180Deg,
  layerBDark,
  layerCLighter,
} from '../../../styles/commonStyles';

import SelectOptions from './SelectOptions';
import { useSelectSwitchDropBoxDispatches } from '../../../../hooks/useSelectSwitchesDispatches';
import SelectionsButton from './SelectionsButton';
import { useSelectSwitchesDisplay } from '../../../../hooks/useSelectSwitchesDisplay';
import { useSelectBoxArrowsState } from '../../../../hooks/useSelectBoxArrowsState';
import { getAllSpecificLocationNames } from '../../../../helpers/helpers';

const SelectMachineOptions = ({ handleClose, data, swt, isMasterControl }) => {
  const isMobile = useMediaQuery({ query: '(max-width:600px)' });

  const hpStations = {
    'blue-hill': {
      address: { lat: 45.5018869, lng: -73.56739189999999 },
      allDevices: [],
      blowers: 'true',
      company_name: 'hayek',
      currently: {},
      daily: [],
      devices: {},
      ebp_message: true,
      latitude: 45.5018869,
      locationAddress: 'Montreal, QC',
      locationId: '0a87e18a-afa3-45d6-af39-d500daf2149e',
      locationName: 'blue hill',
      location_name: 'cario',
      location_name_short: 'haca',
      longitude: -73.56739189999999,
      parent_location_id: '8248a34c-45e9-44ae-b9bd-1b77af9ea779',
      site_maps_ESS: '',
      site_maps_TES: '',
      site_maps_TGS: '',
      specific_address: 'hayek-spec3',
      ssr_quantity: 8,
      switches: 'true',
      switches_number: 2,
      uos_panel_number: 2,
      weather: (5)[
        ({ icon: '01d', tempMin: '5', tempMax: '6', day: 'Tuesday' },
        { icon: '01d', tempMin: '4', tempMax: '4', day: 'Wednesday' },
        { icon: '04d', tempMin: '5', tempMax: '5', day: 'Thursday' },
        { icon: '01d', tempMin: '7', tempMax: '7', day: 'Friday' },
        { icon: '04d', tempMin: '7', tempMax: '7', day: 'Saturday' })
      ],
      zoneId: '0a87e18a-afa3-45d6-af39-d500daf2149e',
      zone_address: 'Montreal, QC',
      zone_devices: [],
      zone_id: '0a87e18a-afa3-45d6-af39-d500daf2149e',
      zone_img_url: 'https://map-images.s3.amazonaws.com/default-map.png',
      zone_name: 'hayek-cario-haca',
      zone_status: 1,
    },
    sharon: { locationName: 'sharon' },
  };

  const locations = Object.keys(data);

  const buttons = ['clear', 'select'];
  const masterControlSelects = useSelector(selectMasterControls);

  const {
    isAllSelected,
    isLocationSelected,
    isSpecificLocationSelected,
    isMachineSelected,
    selectedMachines,
    selectedLocations,
    selectedSpecificLocations,
  } =
    swt === 'ess'
      ? masterControlSelects.ess
      : swt === 'tes'
        ? masterControlSelects.tes
        : masterControlSelects.tgs;

  const allSelectBoxData = {
    isAllSelected,
    isLocationSelected,
    isSpecificLocationSelected,
    isMachineSelected,
    selectedMachines,
    selectedLocations,
    selectedSpecificLocations,
  };

  const { trackArrowState, trackSpecLocationArrowState, specificLocations } =
    useSelectBoxArrowsState(data);

  const [isArrowDown, setIsArrowDown] = useState(trackArrowState);
  const [isSpecLocationArrowDown, setIsSpecLocationArrowDown] = useState(
    trackSpecLocationArrowState,
  );

  const [isSelected, setIsSelected] = useState(false);

  const [specificLocationsNameList, setSpecificLocationsNameList] = useState(
    [],
  );

  const dispatch = useDispatch();

  useEffect(() => {

    const result = getAllSpecificLocationNames(data);
    setSpecificLocationsNameList(result);
  }, [data]);

  const useIndicatorsHandler = (option, machine, extraOption, machineIndex) => {
    const { select } = useSelectSwitchesDisplay(
      option,
      machine,
      extraOption,
      machineIndex,
      specificLocations,
      swt,
      data,
      allSelectBoxData,
      dispatch,
    );

    setIsSelected(select);
  };

  const useButtonsHandler = (button) => {
    useSelectSwitchDropBoxDispatches(
      button,
      allSelectBoxData,
      swt,
      isSelected,
      handleClose,
      data,
      dispatch,
    );
  };

  return (
    <>
      {isMobile ? (
        <Wrapper isMobile={true}>
          <ScrollWrapper isMobile={true} isMasterControl={isMasterControl}>
            <SectionOptions isMobile={true}>
              <SelectOptions
                option='all'
                handleSelect={useIndicatorsHandler}
                isSelected={isAllSelected}
                isMobile={true}
                isMasterControl={isMasterControl}
              />
              {locations.map((location, index) => (
                <SelectOptions
                  key={index}
                  isMobile={true}
                  isHp={swt === 'hp'}
                  isMasterControl={isMasterControl}
                  option={location}
                  data={data[location]}
                  handleSelect={useIndicatorsHandler}
                  isSelected={isLocationSelected[index]}
                  isMachineSelected={
                    isMachineSelected[index] && isMachineSelected[index]
                  }
                  isArrowDown={isArrowDown}
                  setIsArrowDown={setIsArrowDown}
                  allSpecificLocationsName={specificLocationsNameList}
                  isSpecificLocationSelected={isSpecificLocationSelected}
                  isSpecLocationArrowDown={isSpecLocationArrowDown}
                  setIsSpecLocationArrowDown={setIsSpecLocationArrowDown}
                />
              ))}
            </SectionOptions>
          </ScrollWrapper>
          <SectionButtons isMasterControl={isMasterControl}>
            {buttons.map((button, index) => (
              <ButtonWrapper isMasterControl={isMasterControl} key={index}>
                <SelectionsButton
                  title={button}
                  onClickButton={useButtonsHandler}
                  index={index}
                  isMasterControl={isMasterControl}
                />
              </ButtonWrapper>
            ))}
          </SectionButtons>
        </Wrapper>
      ) : (
        <Wrapper>
          <ScrollWrapper>
            <SectionOptions>
              <SelectOptions
                option='all'
                handleSelect={useIndicatorsHandler}
                isSelected={isAllSelected}
              />
              {locations.map((location, index) => (
                <SelectOptions
                  key={index}
                  index={index}
                  option={location}
                  data={data[location]}
                  isHp={swt === 'hp'}
                  hpData={hpStations}
                  handleSelect={useIndicatorsHandler}
                  isSelected={isLocationSelected[index]}
                  isMachineSelected={
                    isMachineSelected[index] && isMachineSelected[index]
                  }
                  isArrowDown={isArrowDown}
                  setIsArrowDown={setIsArrowDown}
                  allSpecificLocationsName={specificLocationsNameList}
                  isSpecificLocationSelected={isSpecificLocationSelected}
                  isSpecLocationArrowDown={isSpecLocationArrowDown}
                  setIsSpecLocationArrowDown={setIsSpecLocationArrowDown}
                />
              ))}
            </SectionOptions>
          </ScrollWrapper>
          <SectionButtons>
            {buttons.map((button, index) => (
              <ButtonWrapper key={index}>
                <SelectionsButton
                  title={button}
                  onClickButton={useButtonsHandler}
                  index={index}
                />
              </ButtonWrapper>
            ))}
          </SectionButtons>
        </Wrapper>
      )}
    </>
  );
};

export default SelectMachineOptions;

const Wrapper = styled.div`
  height: 100%;
  width: 100%;
  margin-top: 5rem;

  ${flexDirectionColumn};
  ${(p) =>
    p.isMobile &&
    css`
      height: auto;
    `}
`;

const ScrollWrapper = styled.div`
  max-height: 184px;
  width: 100%;
  border-radius: 14px 8px 8px 14px;
  ${layerBDark};
  ${flexDirectionColumn}
  padding: 4rem;
  margin-bottom: 4rem;

  ${(p) =>
    p.isMobile &&
    css`
      width: 230px;
      ${layerA}
    `}

  ${(p) =>
    p.isMasterControl &&
    css`
      border-radius: 18px;
    `}
`;
const SectionOptions = styled.div`

  max-height: 176px;
  width: 100%;
  scroll-behavior: smooth;
  overflow-y: scroll;
  ::-webkit-scrollbar {
    width: 10px;
    border: 1px solid #ffffff;
    border-radius: 13px;
  }
  ::-webkit-scrollbar-track {
  }

  ::-webkit-scrollbar-thumb {
    background-color: #ffffff;
    border-radius: 13px;
    border: 1.5px solid transparent;
    background-clip: padding-box;
    height: 40%;
  }

  ::-webkit-scrollbar-button:start:decrement {
    background-repeat: no-repeat;
    background-size: 70%;
    background-position: center;
    height: 10px;

    background-image: url('/images/scrollbar-button-start.svg');
  }
  ::-webkit-scrollbar-button:end:increment {
    background-repeat: no-repeat;
    background-size: 70%;
    background-position: center;
    height: 10px;

    background-image: url('/images/scrollbar-button-end.svg');
  }

  ${(p) =>
    p.isMobile &&
    css`
      ::-webkit-scrollbar {
        display: none;
      }
      height: auto;
      max-height: 223px;
      width: 230px;
      border-radius: 18px;

      ${flexDirectionColumn};
      justify-content: flex-start;
      padding: 2px 0;
      margin-bottom: 4px;
    `}
`;

const SectionButtons = styled.div`
  width: 100%;
  ${justifyContentSpaceBetween}

  ${(p) =>
    p.isMasterControl &&
    css`
      width: 230px;
    `};
`;

const ButtonWrapper = styled.button`
  width: 84px;
  height: 27px;
  border-radius: 18px;
  ${layerBDark}
  ${flexBoxCenter}

  ${(p) =>
    p.isMasterControl &&
    css`
      width: 110px;
      height: 37px;
    `};
`;

